/*
 * File: FilterForm.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/17/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Patient appointments filter form data
 */
const FilterFormModel = [
  {
    name: "statusId",
    label: "Filter Appointment Status",
    type: "select",
    options: []
  },
  {
    name: "dateRange",
    label: "Date Range",
    type: "radiogroup",
    value: "2",
    options: [
      { id: "2", name: "All Appointments" },
      { id: "3", name: "Future Appointments" },
      { id: "4", name: "This Month" },
      { id: "5", name: "Last Month" },
      { id: "6", name: "Last 6 Months" },
      { id: "7", name: "This Year" },
      { id: "8", name: "Last Year" }
    ]
  },
  {
    name: "deleted",
    label: "Include Deleted Appointments",
    type: "switch"
  }
];

export default FilterFormModel;
